function Loading() {
  return (
    <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full min-h-screen antialiased bg-layer-disabled">
      <div id="bars">
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
        <div className="bar" />
      </div>

    </div>

  );
}
export default Loading;
